module.exports = __webpack_public_path__ + "static/media/Shop-By-Vehicle-Icon-White.c5021f76.svg";